"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCountryList } from "@/store/slices/inquirySlice";

export default function InitReduxFromServer({ countryList }) {
  const dispatch = useDispatch();
  const pathname = usePathname();

  useEffect(() => {
    if (countryList) {
      let CountryList = countryList.filter(
        (country) => country.phonecode !== "92"
      );
      dispatch(setCountryList(CountryList));
    }
  }, [countryList, dispatch]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
